export default __webpack_public_path__ + "static/FuturaStdLightOblique-56daf6260c8b75624b3216f45ec560a5.woff2";